import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const [status, setStatus] = useState("checking");
  const [order, setOrder] = useState(null);
  const sessionId = params.get("session_id");
  const orderId = params.get("order_id");

  useEffect(() => {
    if (orderId) {
      api.get(`/orders/${orderId}`).then((res) => setOrder(res.data)).catch(() => {});
    }
  }, [orderId]);

  useEffect(() => {
    if (!sessionId) {
      setStatus("paid");
      return;
    }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          return;
        }
        if (attempts < 8) setTimeout(poll, 2000);
        else setStatus("pending");
      } catch {
        setStatus("pending");
      }
    };
    poll();
  }, [sessionId]);

  const isPickup = order?.fulfilment_method === "pickup";

  return (
    <div className="container-lookers py-24 text-center max-w-lg mx-auto" data-testid="payment-success-page">
      {status === "checking" && <p className="text-zinc-400">Confirming your payment…</p>}
      {status === "paid" && (
        <>
          <h1 className="font-serif text-4xl mb-4 text-zinc-900">
            Nice Look.
          </h1>
          {isPickup ? (
            <div data-testid="pickup-success-details">
              <p className="text-sm text-zinc-500 mb-4">Your order is ready to collect from our Perth studio.</p>
              <div className="text-xs text-zinc-500 bg-teal-50 border border-teal-100 rounded-sm p-4 mb-8 text-left" data-testid="pickup-success-address">
                <div className="font-heading uppercase tracking-wide text-teal-800 mb-1">{order.pickup_address}</div>
                <p>We'll let you know when it's ready for collection. Bring your order number and photo ID.</p>
              </div>
            </div>
          ) : (
            <p className="text-sm text-zinc-500 mb-8">Your preloved designer frames are on their way. We'll email you tracking details once they're dispatched.</p>
          )}
          <p className="text-xs text-zinc-500 bg-[#F8F8F9] border border-neutral-200 rounded-sm p-4 mb-8" data-testid="order-authenticity-note">
            Your frame has already been authenticity checked, condition graded and prepared by Lookers. We'll let you know as soon as it's on the way.
          </p>
          <div className="text-xs text-teal-900 bg-teal-50 border border-teal-100 rounded-sm p-4 mb-8 text-left" data-testid="success-photo-reward">
            <div className="font-heading font-bold uppercase tracking-wide text-teal-800 mb-1">15% off your next pair</div>
            <p className="text-teal-900/80">
              When your frames arrive, send us a photo of you wearing them. Once approved we'll email you a single-use 15% code —
              and your photo may feature on the frame's page.{" "}
              <Link to="/share-your-look" className="underline font-semibold" data-testid="success-photo-reward-link">See how it works</Link>
            </p>
          </div>
          <Link to="/account/orders" className="bg-teal-600 hover:bg-teal-700 text-ink px-6 py-3 text-xs font-heading font-semibold uppercase tracking-wide rounded-full transition-colors" data-testid="view-orders-link">View My Orders</Link>
        </>
      )}
      {status === "pending" && <p className="text-sm text-zinc-500">We're still confirming your payment. Check your orders shortly or contact us if this persists.</p>}
    </div>
  );
}
